import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
const ClearFilter = ({ product, setPrevUrl }) => {
  const translation = getTranslationData();
  const location = useLocation();
  const navigate = useNavigate();
  const clearFilter = () => {
    const params = new URLSearchParams(location.search);
    params.delete("categoryId");
    params.delete("discountSlab");
    params.delete("redemptionType");
    navigate(`${location.pathname}?${params.toString()}`);
  };
  return (
    <div className="clearfilterbox filterdrpbtn">
      <div className="clearfix">
        <div className="clearfilterhead">
          <div className="d-flex justify-content-between align-items-center">
            <div className="">
              <h3 className="fill">{translation?.filters}</h3>
            </div>
            <div
              className=" clearAll_position"
              onClick={clearFilter}
            >
              <i className="fa-solid fa-circle-xmark cursorPointer"></i> &nbsp;
              <a className="text-right">{translation?.clearFilter}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClearFilter;
